module.exports = __webpack_public_path__ + "img/icon-download.aab04703.svg";